import AccountDeletionPage from './AccountDeletionPage';
import React, { useState } from 'react';
import { Routes, Route, Navigate, useParams, useLocation } from 'react-router-dom';
import LandingPage from './LandingPage';
import HomeV2 from './HomeV2';
import Upload from './Upload';
import Admin from './Admin';
import Wizard from './Wizard';
import ProjectList from './ProjectList';
import Dashboard from './Dashboard';
import Production from './Production';
import ForumCollaboratif from './ForumCollaboratif';
import ProjectContribute from './ProjectContribute';
import JourneyAdmin from './JourneyAdmin';
import JourneyStudioV2 from './JourneyStudioV2';
import ContributorStudio from './ContributorStudio';
import ScenarioEditor from './ScenarioEditor';
import AccountPage from './AccountPage';
import MyMedias from './MyMedia';
import SettingsPage from './SettingsPage';
import BillingPage from './BillingPage';
import BillingAdminPage from './BillingAdminPage';
import AccountSettingsPage from './AccountSettingsPage';
import UserProfilePage from './UserProfilePage';
import ProjectRecapWrapper from './ProjectRecapWrapper';
import { GroupList, GroupCreate, GroupDetail } from './GroupModule';
import UserProfile from './UserProfile';
import AuthHandler from './AuthHandler';
import { useAuth } from './AuthContext';
import NotificationsPage from './NotificationsPage';
import AccessLogPage from './AccessLogPage';
import MediaDetails from './MediaDetail';
import Explore from './Explore';
import MessagesPage from './MessagesPage';
import ProjectForum from './ProjectForum';
import TwickEditorPage from './TwickEditorPage';
import CreateMedia from './CreateMedia';
import Decouvrir from './Decouvrir';
import MentionsLegales from './MentionsLegales';
import PolitiqueConfidentialite from './PolitiqueConfidentialite';
import CGU from './CGU';
import PolitiqueCookies from './PolitiqueCookies';
import AccessibiliteRGPD from './AccessibiliteRGPD';
import AboutPage from './AboutPage';
import TeamPage from './TeamPage';
import CareersPage from './CareersPage';
import FAQ from './FAQ';
import ConfidentialiteEtDonnees from './ConfidentialiteEtDonnees';
import Contact from './Contact';
import Blog from './Blog';
import DiscoverWeavevo from './DiscoverWeavevo';
import WeavevoSearch from './WeavevoSearch';
import ActiveUsersPage from './ActiveUsersPage';
import LiveEventsPage from './LiveEventsPage';
import BookingPage from './BookingPage';
import HotelPage from './HotelPage';
import RealEstatePage from './RealEstatePage';
import MuseumPage from './MuseumPage';
import SportPage from './SportPage';
import MediaPage from './MediaPage';
import AIProposalPage from './AIProposalPage';
import GeolocalisationPage from './GeolocalisationPage';
import MapPage from './MapPage';
import WizardFeaturePage from './WizardFeaturePage';
import LivingWeavePage from './LivingWeavePage';
import EarningModelPage from './EarningModelPage';
import DualAIPage from './DualAIPage';
import DualAIGenerationPage from './DualAIGenerationPage';
import DualAIConnectionPage from './DualAIConnectionPage';
import DualAIWorkflowPage from './DualAIWorkflowPage';
import TemplatesPage from './TemplatesPage';
import IndustryPage from './IndustryPage';
import GuidePage from './GuidePage';
import LoomPage from './LoomPage';
import SchoolPage from './SchoolPage';
import CoCreationPage from './CoCreationPage';
import CreatorsInfluencersPage from './CreatorsInfluencersPage';
import { AuthenticatedAppLayout, HomeRouteLayout, PublicSiteLayout } from './SiteLayouts';

const RequireAuth = ({ children }) => {
  const token = localStorage.getItem('kc_token');
  return token ? children : <Navigate to="/" />;
};

const decodeJwtPayload = (token) => {
  try {
    const part = String(token || '').split('.')[1];
    if (!part) return {};
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    const json = decodeURIComponent(
      window.atob(padded).split('').map((c) =>
        '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      ).join('')
    );
    return JSON.parse(json);
  } catch {
    return {};
  }
};

const getStoredUserPayload = () => {
  let stored = {};
  try {
    const raw = localStorage.getItem('kc_user');
    stored = raw ? JSON.parse(raw) : {};
  } catch {}

  // The access token is the source of truth; kc_user can be incomplete.
  const decoded = decodeJwtPayload(localStorage.getItem('kc_token'));
  return { ...stored, ...decoded };
};

const isTokenExpired = (payload = {}) => {
  const exp = Number(payload.exp || 0);
  return exp > 0 && Date.now() >= exp * 1000;
};

const isTmpAdminPayload = (payload = {}) => {
  const preferredUsername = String(payload.preferred_username || payload.username || '')
    .trim()
    .toLowerCase();
  const email = String(payload.email || '').trim().toLowerCase();
  const emailLocalPart = email.includes('@') ? email.split('@')[0] : email;

  // Deliberately strict: this page is for the Keycloak account tmpadm only.
  return preferredUsername === 'tmpadm' || emailLocalPart === 'tmpadm';
};

const clearLocalAuth = () => {
  try {
    ['kc_token', 'kc_user', 'kc_refreshToken', 'token', 'user', 'access_token'].forEach((key) =>
      localStorage.removeItem(key)
    );
  } catch {}
};

const AdminAccessShell = ({ title, subtitle, children }) => (
  <div
    style={{
      minHeight: '100vh',
      padding: '96px 24px 40px',
      display: 'grid',
      placeItems: 'center',
      background: '#f7f9fc',
      color: '#0f172a',
    }}
  >
    <div
      style={{
        width: 'min(520px, 100%)',
        borderRadius: 24,
        padding: 32,
        background: '#fff',
        border: '1px solid rgba(15,23,42,.08)',
        boxShadow: '0 24px 70px rgba(15,23,42,.10)',
      }}
    >
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '7px 11px',
          borderRadius: 999,
          background: 'rgba(37,99,235,.08)',
          color: '#2563eb',
          fontSize: 12,
          fontWeight: 700,
          marginBottom: 16,
        }}
      >
        <span style={{ width: 7, height: 7, borderRadius: 999, background: '#22c55e', display: 'inline-block' }} />
        tmpadm restricted area
      </div>
      <h1 style={{ margin: '0 0 10px', fontSize: 'clamp(30px, 5vw, 42px)', letterSpacing: '-.04em' }}>{title}</h1>
      <p style={{ margin: '0 0 24px', color: '#64748b', fontSize: 15, lineHeight: 1.55 }}>{subtitle}</p>
      {children}
    </div>
  </div>
);

const TmpAdminPasswordLogin = () => {
  const { login, logout } = useAuth();
  const [username, setUsername] = useState('tmpadm');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    const cleanUsername = String(username || '').trim();

    if (!cleanUsername || !password) {
      setError('Enter the tmpadm username and password.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Same simple username/password flow already used by the Home page.
      // The browser never opens the Keycloak login UI.
      const response = await fetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: cleanUsername, password }),
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data?.token) {
        throw new Error(data?.error || data?.message || 'Invalid username or password.');
      }

      const payload = decodeJwtPayload(data.token);
      const candidate = { ...(data.user || {}), ...payload };
      if (!isTmpAdminPayload(candidate)) {
        throw new Error('This page is restricted to the tmpadm account.');
      }

      login(data.token, data.user || {});
    } catch (err) {
      // Do not keep any rejected/expired admin identity around.
      logout?.();
      clearLocalAuth();
      setPassword('');
      setError(err?.message || 'Unable to sign in.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminAccessShell
      title="Active users"
      subtitle="Sign in with the tmpadm username and password to open this administration page."
    >
      <form onSubmit={submit} style={{ display: 'grid', gap: 14 }}>
        <label style={{ display: 'grid', gap: 7, fontSize: 13, fontWeight: 700, color: '#334155' }}>
          Username
          <input
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            autoComplete="username"
            spellCheck="false"
            style={{
              width: '100%',
              border: '1px solid #cbd5e1',
              borderRadius: 12,
              padding: '12px 13px',
              fontSize: 14,
              outline: 'none',
              background: '#fff',
              color: '#0f172a',
            }}
          />
        </label>

        <label style={{ display: 'grid', gap: 7, fontSize: 13, fontWeight: 700, color: '#334155' }}>
          Password
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            autoFocus
            style={{
              width: '100%',
              border: '1px solid #cbd5e1',
              borderRadius: 12,
              padding: '12px 13px',
              fontSize: 14,
              outline: 'none',
              background: '#fff',
              color: '#0f172a',
            }}
          />
        </label>

        {error ? (
          <div
            role="alert"
            style={{
              padding: '11px 12px',
              borderRadius: 11,
              background: '#fef2f2',
              border: '1px solid #fecaca',
              color: '#b91c1c',
              fontSize: 13,
            }}
          >
            {error}
          </div>
        ) : null}

        <button
          type="submit"
          disabled={loading}
          style={{
            border: 0,
            borderRadius: 999,
            padding: '13px 20px',
            background: '#111827',
            color: '#fff',
            fontSize: 14,
            fontWeight: 700,
            cursor: loading ? 'wait' : 'pointer',
            opacity: loading ? .7 : 1,
          }}
        >
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </AdminAccessShell>
  );
};

const RequireTmpAdmin = ({ children }) => {
  const auth = useAuth();
  const token = auth?.token || localStorage.getItem('kc_token');

  if (!token) return <TmpAdminPasswordLogin />;

  const payload = { ...(auth?.user || {}), ...decodeJwtPayload(token) };
  if (isTokenExpired(payload)) {
    auth?.logout?.();
    clearLocalAuth();
    return <TmpAdminPasswordLogin />;
  }

  // Any non-tmpadm session gets the same local username/password form.
  // No redirect to Keycloak is ever triggered from this route.
  return isTmpAdminPayload(payload) ? children : <TmpAdminPasswordLogin />;
};

const GroupDetailWrapper = () => {
  const { groupId } = useParams();
  return <GroupDetail groupId={groupId} />;
};

const UserProfileWrapper = () => {
  const { username } = useParams();
  return <UserProfile username={username} />;
};

const MyMediasRoute = () => {
  const location = useLocation();
  return location.state?.openAddMedia ? <CreateMedia /> : <MyMedias />;
};

const AppRoutes = ({ onLogout }) => (
  <Routes>
    {/* Home stays the source of truth for public chrome. Logged-in Home is embedded in the workspace centrally. */}
    <Route path="/" element={<HomeRouteLayout onLogout={onLogout}><HomeV2 /></HomeRouteLayout>} />
    <Route path="/homeV2" element={<HomeRouteLayout onLogout={onLogout}><HomeV2 /></HomeRouteLayout>} />
    <Route path="/homev2" element={<HomeRouteLayout onLogout={onLogout}><HomeV2 /></HomeRouteLayout>} />

    {/* One centralized public shell for every non-Home public/static/marketing page. */}
    <Route element={<PublicSiteLayout onLogout={onLogout} />}>
      <Route path="/classic-home" element={<LandingPage />} />
      <Route path="/decouvrir" element={<Decouvrir />} />
      <Route path="/discover-weavevo" element={<DiscoverWeavevo />} />

      <Route path="/use-cases/live-events" element={<LiveEventsPage />} />
      <Route path="/use-cases/booking" element={<BookingPage />} />
      <Route path="/use-cases/hotel" element={<HotelPage />} />
      <Route path="/use-cases/real-estate" element={<RealEstatePage />} />
      <Route path="/use-cases/museum" element={<MuseumPage />} />
      <Route path="/use-cases/sport" element={<SportPage />} />
      <Route path="/use-cases/media" element={<MediaPage />} />
      <Route path="/use-cases/industry" element={<IndustryPage />} />
      <Route path="/use-cases/creators-influencers" element={<CreatorsInfluencersPage />} />
      <Route path="/use-cases/social-media-weave" element={<CreatorsInfluencersPage />} />
      <Route path="/use-cases/ai-proposal" element={<AIProposalPage />} />
      <Route path="/use-cases/geolocalisation" element={<GeolocalisationPage />} />
      <Route path="/use-cases/guide" element={<GuidePage />} />
      <Route path="/school" element={<SchoolPage />} />
      <Route path="/use-cases/school" element={<SchoolPage />} />
      <Route path="/guide" element={<GuidePage />} />
      <Route path="/use-cases/map" element={<MapPage />} />
      <Route path="/use-cases/wizard" element={<WizardFeaturePage />} />
      <Route path="/frictionless-co-creation" element={<CoCreationPage />} />
      <Route path="/cocreation" element={<CoCreationPage />} />

      <Route path="/living-weave-pipeline" element={<LivingWeavePage />} />
      <Route path="/earning-model" element={<EarningModelPage />} />
      <Route path="/dual-ai" element={<DualAIPage />} />
      <Route path="/dual-ai/generation" element={<DualAIGenerationPage />} />
      <Route path="/dual-ai/connexion" element={<DualAIConnectionPage />} />
      <Route path="/dual-ai/workflow" element={<DualAIWorkflowPage />} />
      <Route path="/loom" element={<LoomPage />} />
      <Route path="/template" element={<TemplatesPage />} />
      <Route path="/templates" element={<TemplatesPage />} />
      <Route path="/mentions-legales" element={<MentionsLegales />} />
      <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
      <Route path="/cgu" element={<CGU />} />
      <Route path="/politique-cookies" element={<PolitiqueCookies />} />
      <Route path="/accessibilite-rgpd" element={<AccessibiliteRGPD />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/team" element={<TeamPage />} />
      <Route path="/a-propos" element={<TeamPage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/confidentialite-et-donnees" element={<ConfidentialiteEtDonnees />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blog" element={<Blog />} />
    </Route>

    <Route path="/auth/callback" element={<AuthHandler />} />

    {/* Standalone admin exception: its own tmpadm gate must run before the generic auth redirect. */}
    <Route
      path="/active-users"
      element={
        <RequireTmpAdmin>
          <AuthenticatedAppLayout onLogout={onLogout}>
            <ActiveUsersPage />
          </AuthenticatedAppLayout>
        </RequireTmpAdmin>
      }
    />

    {/* One centralized authenticated shell for every workspace page. */}
    <Route
      element={
        <RequireAuth>
          <AuthenticatedAppLayout onLogout={onLogout} />
        </RequireAuth>
      }
    >
      <Route path="/upload" element={<Upload />} />
      <Route path="/wizard" element={<Wizard />} />
      <Route path="/projects" element={<ProjectList />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/portfolio" element={<Production />} />
      <Route path="/forum" element={<ForumCollaboratif />} />
      <Route path="/project/:id" element={<ProjectContribute />} />
      <Route path="/project/:id/manage" element={<JourneyAdmin />} />
      <Route path="/project/:id/studio" element={<JourneyStudioV2 />} />
      <Route path="/project/:id/contributor-studio" element={<ContributorStudio />} />
      <Route path="/project/:id/scenario" element={<ScenarioEditor />} />
      <Route path="/public" element={<Admin />} />
      <Route path="/projects/:id/recap-ui" element={<ProjectRecapWrapper />} />
      <Route path="/groups" element={<GroupList />} />
      <Route path="/groups/create" element={<GroupCreate />} />
      <Route path="/groups/:groupId" element={<GroupDetailWrapper />} />
      <Route path="/users/:username" element={<UserProfileWrapper />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/myMedias" element={<MyMediasRoute />} />
      <Route path="/mediaDetails/:id" element={<MediaDetails />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/billing" element={<BillingPage />} />
      <Route path="/admin/billing" element={<BillingAdminPage />} />
      <Route path="/settings/account" element={<AccountSettingsPage />} />
      <Route path="/profile/:username" element={<UserProfilePage />} />
      <Route path="/notifications" element={<NotificationsPage />} />
      <Route path="/admin/access-log" element={<AccessLogPage />} />
      <Route path="/explore" element={<Explore />} />
      <Route path="/search" element={<WeavevoSearch />} />
      <Route path="/projects/:id/forum" element={<ProjectForum />} />
      <Route path="/projects/:id/twick" element={<TwickEditorPage />} />
      <Route path="/twick" element={<TwickEditorPage />} />
      <Route path="/messages" element={<MessagesPage />} />
      <Route path="/mymedia" element={<CreateMedia />} />
      <Route path="/create-media" element={<CreateMedia />} />
    </Route>

    <Route path="/account-deletion" element={<AccountDeletionPage />} />
    <Route path="/delete-account" element={<AccountDeletionPage />} />
    <Route path="*" element={<Navigate to="/" />} />
  </Routes>
);

export default AppRoutes;
